import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getPropertyTypeService = (
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  return realBricksApi.get(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const addPropertyTypeService = (body) => {
  return realBricksApi.post(API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType, body);
};

export const getPropertyTypeByIDService = (id) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}/${id}`
  );
};

export const updatePropertyTypeService = (id, body) => {
  return realBricksApi.patch(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}/${id}`,
    body
  );
};

export const deletePropertyTypeService = (id) => {
  return realBricksApi.delete(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}/${id}`
  );
};

export const getAllPropertyTypes = (cancelToken) => {
  return realBricksApi.get(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}?page=1&&limit=100`,
    {
      cancelToken,
    }
  );
};
